module.exports = __webpack_public_path__ + "static/actionbar-actions-dont-73052679aa584816f844740e37a7c4c5.png";